import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'
import Text from 'UIKit/Text/Text'
import AlchemyDisplayContent from 'components/AlchemyDisplayContent'
import { ICommonBonus } from 'config/types/bonus'
import React from 'react'
import { Trans } from 'react-i18next'

interface InstructionDetailProps {
  bonus: ICommonBonus
}

const InstructionDetails: React.FC<InstructionDetailProps & BoxProps> = ({ bonus, ...props }) => {
  return (
    <Box {...props}>
      <Text fontSize="14px" fontWeight="700" mb="10px">
        <Trans>Instruction</Trans>
      </Text>
      <Box>
        <Text fontSize="14px" fontWeight="400" color="textSubtle">
          <AlchemyDisplayContent my="16px" content={bonus.info.instruction} />
        </Text>
      </Box>
    </Box>
  )
}

export default InstructionDetails
